/**
 * Template: Page - History
 * ------------------------------------------------------------------------------
 */
import {load} from '@shopify/theme-sections';
import '../../styles/templates/page.lp_salone-24.scss';

document.addEventListener('DOMContentLoaded', () => {

});
